import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

const menuAdmin = [
  { path: '/', label: 'Dashboard' },
  { path: '/estoque', label: 'Estoque' },
  { path: '/clientes', label: 'Clientes' },
  { path: '/vendas', label: 'Vendas' },
  { path: '/crm', label: 'CRM' },
  { path: '/financeiro', label: 'Financeiro' },
  { path: '/relatorios', label: 'Relatórios' },
  { path: '/fornecedores', label: 'Fornecedores' },
  { path: '/usuarios', label: 'Usuários' },
];

const menuVendedor = [
  { path: '/', label: 'Dashboard' },
  { path: '/estoque', label: 'Estoque' },
  { path: '/clientes', label: 'Clientes' },
  { path: '/vendas', label: 'Vendas' },
  { path: '/crm', label: 'CRM' },
];

export default function Layout({ children }) {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [menuAberto, setMenuAberto] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isAdmin = usuario?.nivel === 'admin' || usuario?.nivel === 'gerente';
  const menu = isAdmin ? menuAdmin : menuVendedor;

  const paginaAtual = location.pathname === '/perfil' ? 'Meu perfil'
    : menu.find(m => location.pathname === m.path || (m.path !== '/' && location.pathname.startsWith(m.path)))?.label || 'AutoMais';

  const iniciais = usuario?.nome?.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase() || 'U';

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#F0F3F7', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
      <div style={{ width: isMobile ? '240px' : '220px', background: '#1A3A5C', display: 'flex', flexDirection: 'column', flexShrink: 0, position: isMobile ? 'fixed' : 'relative', top: 0, left: isMobile ? (menuAberto ? 0 : '-240px') : 0, height: '100vh', zIndex: 100, transition: 'left 0.25s ease' }}>
        <div style={{ padding: '20px 18px 16px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '4px' }}>
            <div style={{ width: '32px', height: '32px', background: '#1E5FA5', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '700', fontSize: '14px', color: '#fff' }}>A+</div>
            <span style={{ fontSize: '18px', fontWeight: '700', color: '#fff', letterSpacing: '-0.3px' }}>AutoMais</span>
          </div>
          <span style={{ color: 'rgba(255,255,255,0.35)', fontSize: '11px', marginLeft: '42px', display: 'block' }}>Sistema de Gestão</span>
        </div>
        <nav style={{ flex: 1, padding: '10px 0', overflowY: 'auto' }}>
          {menu.map(item => {
            const active = location.pathname === item.path || (item.path !== '/' && location.pathname.startsWith(item.path));
            return (
              <button key={item.path} onClick={() => { navigate(item.path); if(isMobile) setMenuAberto(false); }}
                style={{ width: '100%', padding: '9px 18px', background: active ? 'rgba(255,255,255,0.12)' : 'transparent', border: 'none', borderLeft: active ? '3px solid #7FB8F5' : '3px solid transparent', color: active ? '#fff' : 'rgba(255,255,255,0.5)', textAlign: 'left', cursor: 'pointer', fontSize: '13.5px', fontWeight: active ? '600' : '400', fontFamily: "'DM Sans',system-ui,sans-serif", display: 'flex', alignItems: 'center', gap: '9px' }}>
                <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: active ? '#7FB8F5' : 'rgba(255,255,255,0.25)', flexShrink: 0, display: 'inline-block' }}></span>
                {item.label}
              </button>
            );
          })}
        </nav>
        <div style={{ padding: '14px 18px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
          <button onClick={() => navigate('/perfil')}
            style={{ width: '100%', background: 'transparent', border: 'none', padding: '0 0 10px 0', cursor: 'pointer', textAlign: 'left', display: 'flex', alignItems: 'center', gap: '9px' }}>
            <div style={{ width: '30px', height: '30px', borderRadius: '50%', background: location.pathname === '/perfil' ? '#FF6B00' : '#1E5FA5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: '700', color: '#fff', flexShrink: 0 }}>{iniciais}</div>
            <div>
              <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: '13px', fontWeight: '500' }}>{usuario?.nome || 'Usuário'}</div>
              <div style={{ color: 'rgba(255,255,255,0.35)', fontSize: '11px' }}>{usuario?.nivel} · <span style={{ color: 'rgba(255,165,0,0.7)' }}>meu perfil</span></div>
            </div>
          </button>
          <button onClick={logout} style={{ background: 'transparent', border: '1px solid rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.45)', padding: '5px 10px', borderRadius: '6px', cursor: 'pointer', fontSize: '11px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>Sair</button>
        </div>
      </div>
      {isMobile && menuAberto && (
        <div onClick={() => setMenuAberto(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 99 }} />
      )}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        {isMobile && (
          <div style={{ background: '#1A3A5C', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: '12px', flexShrink: 0 }}>
            <button onClick={() => setMenuAberto(!menuAberto)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px', display: 'flex', flexDirection: 'column', gap: '5px' }}>
              <span style={{ display: 'block', width: '22px', height: '2px', background: '#fff' }}></span>
              <span style={{ display: 'block', width: '22px', height: '2px', background: '#fff' }}></span>
              <span style={{ display: 'block', width: '22px', height: '2px', background: '#fff' }}></span>
            </button>
            <div style={{ fontSize: '15px', fontWeight: '700', color: '#fff' }}>{paginaAtual}</div>
          </div>
        )}
        <div style={{ background: '#fff', borderBottom: '1px solid rgba(26,58,92,0.1)', height: '52px', display: 'flex', alignItems: 'center', padding: '0 24px', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 10 }}>
          <span style={{ fontSize: '15px', fontWeight: '600', color: '#1C2533' }}>{paginaAtual}</span>
          <span style={{ fontSize: '12px', color: '#9AA3AE' }}>{new Date().toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long' })}</span>
        </div>
        <div style={{ flex: 1, padding: '24px', overflowY: 'auto' }}>{children}</div>
      </div>
    </div>
  );
}
